module.exports = "<!--\r\nAuto-generated\r\nDo not edit!!!\r\n-->\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main